// extracted by mini-css-extract-plugin
export default {"lessonTimetable":"calrt3Qb"};